import { render } from "./BattleController.vue?vue&type=template&id=a6f1122c&scoped=true"
import script from "./BattleController.vue?vue&type=script&lang=js"
export * from "./BattleController.vue?vue&type=script&lang=js"

import "./BattleController.vue?vue&type=style&index=0&id=a6f1122c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6f1122c"]])

export default __exports__